<template>
  <span :class="colorClass">
    <i
      v-if="alarmStatus"
      class="fas fa-bell"
      aria-hidden="true"
    />
    <i
      v-else
      class="fas fa-bell-slash"
      aria-hidden="true"
    />
  </span>
</template>

<script>
export default {
  props: {
    alarmStatus: {
      type: Boolean,
      required: true,
    },
    displaying: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    colorClass() {
      if (!this.alarmStatus) {
        return 'alarm-status__icon--disabled';
      }

      return 'alarm-status__icon';
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .alarm-status
    &__icon
      border: 1px solid transparent
      border-radius: 3px
      padding: 2px 7px
      &--disabled
        border: 1px solid transparent
        color: var(--color-gray-intermediary)
        border-radius: 3px
        padding: 2px 4px
</style>
